import { render, staticRenderFns } from "./FormTableComponentTd.vue?vue&type=template&id=60c8096c&scoped=true"
import script from "./FormTableComponentTd.vue?vue&type=script&lang=js"
export * from "./FormTableComponentTd.vue?vue&type=script&lang=js"
import style0 from "./FormTableComponentTd.vue?vue&type=style&index=0&id=60c8096c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c8096c",
  null
  
)

export default component.exports